// @mui
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack, { StackProps } from '@mui/material/Stack';
// components
import Iconify from 'src/components/iconify';
import { useSelector } from 'src/redux/store';

// ----------------------------------------------------------------------

export type IUserTableFilters = {
  name: string;
  // rol: string[];
  status: string;
};

export type IUserTableFilterValue = string | string[];

type Props = StackProps & {
  filters: IUserTableFilters;
  onFilters: (name: string, value: IUserTableFilterValue) => void;
  //
  onResetFilters: VoidFunction;
  //
  results: number;
};

const MeetFilters = ({
  filters,
  onFilters,
  //
  onResetFilters,
  //
  results,
  ...other
}: Props) => {
  const handleRemoveStatus = () => {
    onFilters('status', 'all');
  };

  const handleRemoveName = () => {
    onFilters('name', '');
  };

  const deleteAllFilters = () => {
    onResetFilters();
  };

  const { totalRecords } = useSelector((state) => state.table);

  return (
    <Stack spacing={1.5} {...other}>
      <Box sx={{ typography: 'body2' }}>
        <strong>{totalRecords}{' '}</strong>
        <Box component="span" sx={{ color: 'text.secondary', ml: 0.25 }}>
          Resultados encontrados
        </Box>
      </Box>

      <Stack flexGrow={1} spacing={1} direction="row" flexWrap="wrap" alignItems="center">
        {filters.status !== 'all' && (
          <Block label="Estatus:">
            <Chip size="small" label={filters.status} onDelete={handleRemoveStatus} />
          </Block>
        )}
        {filters.name !== '' && (
          <Block label="Nombre:">
            <Chip size="small" label={filters.name} onDelete={handleRemoveName} />
          </Block>
        )}

        <Button
          color="error"
          onClick={deleteAllFilters}
          startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
        >
          Borrar todos
        </Button>
      </Stack>
    </Stack>
  );
};

export default MeetFilters;

// ----------

type BlockProps = StackProps & {
  label: string;
};

function Block({ label, children, sx, ...other }: BlockProps) {
  return (
    <Stack
      component={Paper}
      variant="outlined"
      spacing={1}
      direction="row"
      sx={{
        p: 1,
        borderRadius: 1,
        overflow: 'hidden',
        borderStyle: 'dashed',
        ...sx,
      }}
      {...other}
    >
      <Box component="span" sx={{ typography: 'subtitle2' }}>
        {label}
      </Box>

      <Stack spacing={1} direction="row" flexWrap="wrap">
        {children}
      </Stack>
    </Stack>
  );
}
